"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.thirdPartyApi = exports.fetchTestToolLink = exports.deleteTestToolLink = exports.updateTestToolLink = exports.addTestToolLink = exports.fetchTestToolLinks = void 0;
// TESTS TOOLLINKS
const fetchTestToolLinks = (caller) => ({ accountId, testId, queryParams }) => caller(`/api/core/accounts/${accountId}/tests/${testId}/toollinks`).get(queryParams);
exports.fetchTestToolLinks = fetchTestToolLinks;
const addTestToolLink = (caller) => ({ accountId, testId, payload }) => caller(`/api/core/accounts/${accountId}/tests/${testId}/toollinks`).post(payload);
exports.addTestToolLink = addTestToolLink;
const updateTestToolLink = (caller) => ({ accountId, testId, toolLinkId, payload }) => caller(`/api/core/accounts/${accountId}/tests/${testId}/toollinks/${toolLinkId}`).patch(payload);
exports.updateTestToolLink = updateTestToolLink;
const deleteTestToolLink = (caller) => ({ accountId, testId, toolLinkId }) => {
    return caller(`/api/core/accounts/${accountId}/tests/${testId}/toollinks/${toolLinkId}`).delete();
};
exports.deleteTestToolLink = deleteTestToolLink;
const fetchTestToolLink = (caller) => ({ accountId, testId, toolLinkId }) => caller(`/api/core/accounts/${accountId}/tests/${testId}/toollinks/${toolLinkId}`).get();
exports.fetchTestToolLink = fetchTestToolLink;
const thirdPartyApi = (caller) => ({
    fetchTestToolLinks: (0, exports.fetchTestToolLinks)(caller),
    fetchTestToolLink: (0, exports.fetchTestToolLink)(caller),
    deleteTestToolLink: (0, exports.deleteTestToolLink)(caller),
    updateTestToolLink: (0, exports.updateTestToolLink)(caller),
    addTestToolLink: (0, exports.addTestToolLink)(caller),
});
exports.thirdPartyApi = thirdPartyApi;
//# sourceMappingURL=api.js.map